var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6V11.2533C7.36 11.4533 7.29333 11.6667 7.14 11.8067C7.07832 11.8685 7.00506 11.9175 6.92441 11.951C6.84376 11.9844 6.75731 12.0016 6.67 12.0016C6.58268 12.0016 6.49623 11.9844 6.41558 11.951C6.33493 11.9175 6.26167 11.8685 6.2 11.8067L4.86 10.4667C4.78729 10.3956 4.732 10.3087 4.69846 10.2127C4.66492 10.1167 4.65404 10.0142 4.66666 9.91333V6H4.64666L0.806663 1.08C0.698401 0.94102 0.649552 0.764839 0.670788 0.589953C0.692024 0.415068 0.781619 0.255698 0.919996 0.146667C1.04666 0.0533334 1.18666 0 1.33333 0H10.6667C10.8133 0 10.9533 0.0533334 11.08 0.146667C11.2184 0.255698 11.308 0.415068 11.3292 0.589953C11.3504 0.764839 11.3016 0.94102 11.1933 1.08L7.35333 6H7.33333Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon--filter.b38f9b20fdd17d30018b16e0b119c109.svg";
export { ForwardRef as ReactComponent };